export enum EGeneralUrls {
  TENANT = 'tenant',
  ANIMALS = 'animals',
  SPECIES = 'species',
  COLORS = 'colors',
}
